<template>
  <span class="position--relative">
    <strong
      class="font--18px font--800"
      :class="required ? 'is-essential' : ''"
    >{{label}}</strong>
    <!-- <form-button-icon
      class="btn-icon--sm text--middle text--blue font--18px position--absolute right--0px top--50% -mt--19px -mr--40px"
      icon="help_outline"
    ></form-button-icon> -->
  </span>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    required: { type: Boolean, default: false }
  },
  components: {
    // FormButtonIcon: () => import('@/component/ui2/button/FormButtonIcon')
  }
}
</script>
